function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import CropperElement from '@cropper/element';
import { CROPPER_IMAGE, CROPPER_CANVAS, on, EVENT_ACTION_START, EVENT_ACTION_END, EVENT_ACTION, EVENT_LOAD, off, ACTION_TRANSFORM, ACTION_ROTATE, ACTION_SCALE, ACTION_NONE, CROPPER_SELECTION, ACTION_MOVE, once, EVENT_ERROR, isFunction, isNumber, toAngleInRadian, multiplyMatrices, EVENT_TRANSFORM } from '@cropper/utils';
var style = ":host{display:inline-block}img{display:block;height:100%;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}";
var canvasCache = new WeakMap();
var NATIVE_ATTRIBUTES = ['alt', 'crossorigin', 'decoding', 'elementtiming', 'fetchpriority', 'loading', 'referrerpolicy', 'sizes', 'src', 'srcset'];

var CropperImage = /*#__PURE__*/function (_CropperElement) {
  _inherits(CropperImage, _CropperElement);

  var _super = _createSuper(CropperImage);

  function CropperImage() {
    var _this;

    _classCallCheck(this, CropperImage);

    _this = _super.apply(this, arguments);
    _this.$matrix = [1, 0, 0, 1, 0, 0];
    _this.$onLoad = null;
    _this.$onCanvasAction = null;
    _this.$onCanvasActionEnd = null;
    _this.$onCanvasActionStart = null;
    _this.$actionStartTarget = null;
    _this.$style = style;
    _this.$image = new Image();
    _this.initialCenterSize = 'contain';
    _this.rotatable = false;
    _this.scalable = false;
    _this.skewable = false;
    _this.slottable = false;
    _this.translatable = false; // Native attributes

    _this.alt = '';
    _this.crossorigin = '';
    _this.decoding = '';
    _this.elementtiming = '';
    _this.fetchpriority = '';
    _this.loading = '';
    _this.referrerpolicy = '';
    _this.sizes = '';
    _this.src = '';
    _this.srcset = '';
    return _this;
  }

  _createClass(CropperImage, [{
    key: "$canvas",
    get: function get() {
      return canvasCache.get(this);
    },
    set: function set(element) {
      canvasCache.set(this, element);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      if (Object.is(newValue, oldValue)) {
        return;
      }

      _get(_getPrototypeOf(CropperImage.prototype), "attributeChangedCallback", this).call(this, name, oldValue, newValue); // Inherits the native attributes


      if (NATIVE_ATTRIBUTES.includes(name)) {
        this.$image.setAttribute(name, newValue);
      }
    }
  }, {
    key: "$propertyChangedCallback",
    value: function $propertyChangedCallback(name, oldValue, newValue) {
      var _this2 = this;

      if (Object.is(newValue, oldValue)) {
        return;
      }

      _get(_getPrototypeOf(CropperImage.prototype), "$propertyChangedCallback", this).call(this, name, oldValue, newValue);

      switch (name) {
        case 'initialCenterSize':
          this.$nextTick(function () {
            _this2.$center(newValue);
          });
          break;
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;

      _get(_getPrototypeOf(CropperImage.prototype), "connectedCallback", this).call(this);

      var $image = this.$image;
      var $canvas = this.closest(this.$getTagNameOf(CROPPER_CANVAS));

      if ($canvas) {
        this.$canvas = $canvas;
        this.$setStyles({
          // Make it a block element to avoid side effects (#1074).
          display: 'block',
          position: 'absolute'
        });

        this.$onCanvasActionStart = function (event) {
          var _a, _b;

          _this3.$actionStartTarget = (_b = (_a = event.detail) === null || _a === void 0 ? void 0 : _a.relatedEvent) === null || _b === void 0 ? void 0 : _b.target;
        };

        this.$onCanvasActionEnd = function () {
          _this3.$actionStartTarget = null;
        };

        this.$onCanvasAction = this.$handleAction.bind(this);
        on($canvas, EVENT_ACTION_START, this.$onCanvasActionStart);
        on($canvas, EVENT_ACTION_END, this.$onCanvasActionEnd);
        on($canvas, EVENT_ACTION, this.$onCanvasAction);
      }

      this.$onLoad = this.$handleLoad.bind(this);
      on($image, EVENT_LOAD, this.$onLoad);
      this.$getShadowRoot().appendChild($image);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      var $image = this.$image,
          $canvas = this.$canvas;

      if ($canvas) {
        if (this.$onCanvasActionStart) {
          off($canvas, EVENT_ACTION_START, this.$onCanvasActionStart);
          this.$onCanvasActionStart = null;
        }

        if (this.$onCanvasActionEnd) {
          off($canvas, EVENT_ACTION_END, this.$onCanvasActionEnd);
          this.$onCanvasActionEnd = null;
        }

        if (this.$onCanvasAction) {
          off($canvas, EVENT_ACTION, this.$onCanvasAction);
          this.$onCanvasAction = null;
        }
      }

      if ($image && this.$onLoad) {
        off($image, EVENT_LOAD, this.$onLoad);
        this.$onLoad = null;
      }

      this.$getShadowRoot().removeChild($image);

      _get(_getPrototypeOf(CropperImage.prototype), "disconnectedCallback", this).call(this);
    }
  }, {
    key: "$handleLoad",
    value: function $handleLoad() {
      var $image = this.$image;
      this.$setStyles({
        width: $image.naturalWidth,
        height: $image.naturalHeight
      });

      if (this.$canvas) {
        this.$center(this.initialCenterSize);
      }
    }
  }, {
    key: "$handleAction",
    value: function $handleAction(event) {
      if (this.hidden || !(this.rotatable || this.scalable || this.translatable)) {
        return;
      }

      var $canvas = this.$canvas;
      var detail = event.detail;

      if (detail) {
        var relatedEvent = detail.relatedEvent;
        var action = detail.action;

        if (action === ACTION_TRANSFORM && (!this.rotatable || !this.scalable)) {
          if (this.rotatable) {
            action = ACTION_ROTATE;
          } else if (this.scalable) {
            action = ACTION_SCALE;
          } else {
            action = ACTION_NONE;
          }
        }

        switch (action) {
          case ACTION_MOVE:
            if (this.translatable) {
              var $selection = null;

              if (relatedEvent) {
                $selection = relatedEvent.target.closest(this.$getTagNameOf(CROPPER_SELECTION));
              }

              if (!$selection) {
                $selection = $canvas.querySelector(this.$getTagNameOf(CROPPER_SELECTION));
              }

              if ($selection && $selection.multiple && !$selection.active) {
                $selection = $canvas.querySelector("".concat(this.$getTagNameOf(CROPPER_SELECTION), "[active]"));
              }

              if (!$selection || $selection.hidden || !$selection.movable || $selection.dynamic || !(this.$actionStartTarget && $selection.contains(this.$actionStartTarget))) {
                this.$move(detail.endX - detail.startX, detail.endY - detail.startY);
              }
            }

            break;

          case ACTION_ROTATE:
            if (this.rotatable) {
              if (relatedEvent) {
                var _this$getBoundingClie = this.getBoundingClientRect(),
                    x = _this$getBoundingClie.x,
                    y = _this$getBoundingClie.y;

                this.$rotate(detail.rotate, relatedEvent.clientX - x, relatedEvent.clientY - y);
              } else {
                this.$rotate(detail.rotate);
              }
            }

            break;

          case ACTION_SCALE:
            if (this.scalable) {
              if (relatedEvent) {
                var _$selection = relatedEvent.target.closest(this.$getTagNameOf(CROPPER_SELECTION));

                if (!_$selection || !_$selection.zoomable || _$selection.zoomable && _$selection.dynamic) {
                  var _this$getBoundingClie2 = this.getBoundingClientRect(),
                      _x = _this$getBoundingClie2.x,
                      _y = _this$getBoundingClie2.y;

                  this.$zoom(detail.scale, relatedEvent.clientX - _x, relatedEvent.clientY - _y);
                }
              } else {
                this.$zoom(detail.scale);
              }
            }

            break;

          case ACTION_TRANSFORM:
            if (this.rotatable && this.scalable) {
              var rotate = detail.rotate;
              var scale = detail.scale;

              if (scale < 0) {
                scale = 1 / (1 - scale);
              } else {
                scale += 1;
              }

              var cos = Math.cos(rotate);
              var sin = Math.sin(rotate);
              var scaleX = cos * scale,
                  skewY = sin * scale,
                  skewX = -sin * scale,
                  scaleY = cos * scale;

              if (relatedEvent) {
                var clientRect = this.getBoundingClientRect();

                var _x2 = relatedEvent.clientX - clientRect.x;

                var _y2 = relatedEvent.clientY - clientRect.y;

                var _this$$matrix = _slicedToArray(this.$matrix, 4),
                    a = _this$$matrix[0],
                    b = _this$$matrix[1],
                    c = _this$$matrix[2],
                    d = _this$$matrix[3];

                var originX = clientRect.width / 2;
                var originY = clientRect.height / 2;
                var moveX = _x2 - originX;
                var moveY = _y2 - originY;
                var translateX = (moveX * d - c * moveY) / (a * d - c * b);
                var translateY = (moveY * a - b * moveX) / (a * d - c * b);
                /**
                 * Equals to
                 * this.$rotate(rotate, x, y);
                 * this.$scale(scale, x, y);
                 */

                this.$transform(scaleX, skewY, skewX, scaleY, translateX * (1 - scaleX) + translateY * skewX, translateY * (1 - scaleY) + translateX * skewY);
              } else {
                /**
                 * Equals to
                 * this.$rotate(rotate);
                 * this.$scale(scale);
                 */
                this.$transform(scaleX, skewY, skewX, scaleY, 0, 0);
              }
            }

            break;
        }
      }
    }
    /**
     * Defers the callback to execute after successfully loading the image.
     * @param {Function} [callback] The callback to execute after successfully loading the image.
     * @returns {Promise} Returns a promise that resolves to the image element.
     */

  }, {
    key: "$ready",
    value: function $ready(callback) {
      var $image = this.$image;
      var promise = new Promise(function (resolve, reject) {
        var error = new Error('Failed to load the image source');

        if ($image.complete) {
          if ($image.naturalWidth > 0 && $image.naturalHeight > 0) {
            resolve($image);
          } else {
            reject(error);
          }
        } else {
          var onLoad = function onLoad() {
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            off($image, EVENT_ERROR, onError); // Ensure the image is fully rendered.

            setTimeout(function () {
              resolve($image);
            });
          };

          var onError = function onError() {
            off($image, EVENT_LOAD, onLoad);
            reject(error);
          };

          once($image, EVENT_LOAD, onLoad);
          once($image, EVENT_ERROR, onError);
        }
      });

      if (isFunction(callback)) {
        promise.then(function (image) {
          callback(image);
          return image;
        });
      }

      return promise;
    }
    /**
     * Aligns the image to the center of its parent element.
     * @param {string} [size] The size of the image.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$center",
    value: function $center(size) {
      var parentElement = this.parentElement;

      if (!parentElement) {
        return this;
      }

      var container = parentElement.getBoundingClientRect();
      var containerWidth = container.width;
      var containerHeight = container.height;

      var _this$getBoundingClie3 = this.getBoundingClientRect(),
          x = _this$getBoundingClie3.x,
          y = _this$getBoundingClie3.y,
          width = _this$getBoundingClie3.width,
          height = _this$getBoundingClie3.height;

      var startX = x + width / 2;
      var startY = y + height / 2;
      var endX = container.x + containerWidth / 2;
      var endY = container.y + containerHeight / 2;
      this.$move(endX - startX, endY - startY);

      if (size && (width !== containerWidth || height !== containerHeight)) {
        var scaleX = containerWidth / width;
        var scaleY = containerHeight / height;

        switch (size) {
          case 'cover':
            this.$scale(Math.max(scaleX, scaleY));
            break;

          case 'contain':
            this.$scale(Math.min(scaleX, scaleY));
            break;
        }
      }

      return this;
    }
    /**
     * Moves the image.
     * @param {number} x The moving distance in the horizontal direction.
     * @param {number} [y] The moving distance in the vertical direction.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$move",
    value: function $move(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;

      if (this.translatable && isNumber(x) && isNumber(y)) {
        var _this$$matrix2 = _slicedToArray(this.$matrix, 4),
            a = _this$$matrix2[0],
            b = _this$$matrix2[1],
            c = _this$$matrix2[2],
            d = _this$$matrix2[3];

        var e = (x * d - c * y) / (a * d - c * b);
        var f = (y * a - b * x) / (a * d - c * b);
        this.$translate(e, f);
      }

      return this;
    }
    /**
     * Moves the image to a specific position.
     * @param {number} x The new position in the horizontal direction.
     * @param {number} [y] The new position in the vertical direction.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$moveTo",
    value: function $moveTo(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;

      if (this.translatable && isNumber(x) && isNumber(y)) {
        var _this$$matrix3 = _slicedToArray(this.$matrix, 4),
            a = _this$$matrix3[0],
            b = _this$$matrix3[1],
            c = _this$$matrix3[2],
            d = _this$$matrix3[3];

        var e = (x * d - c * y) / (a * d - c * b);
        var f = (y * a - b * x) / (a * d - c * b);
        this.$setTransform(a, b, c, d, e, f);
      }

      return this;
    }
    /**
     * Rotates the image.
     * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate}
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/rotate}
     * @param {number|string} angle The rotation angle (in radians).
     * @param {number} [x] The rotation origin in the horizontal, defaults to the center of the image.
     * @param {number} [y] The rotation origin in the vertical, defaults to the center of the image.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$rotate",
    value: function $rotate(angle, x, y) {
      if (this.rotatable) {
        var radian = toAngleInRadian(angle);
        var cos = Math.cos(radian);
        var sin = Math.sin(radian);
        var scaleX = cos,
            skewY = sin,
            skewX = -sin,
            scaleY = cos;

        if (isNumber(x) && isNumber(y)) {
          var _this$$matrix4 = _slicedToArray(this.$matrix, 4),
              a = _this$$matrix4[0],
              b = _this$$matrix4[1],
              c = _this$$matrix4[2],
              d = _this$$matrix4[3];

          var _this$getBoundingClie4 = this.getBoundingClientRect(),
              width = _this$getBoundingClie4.width,
              height = _this$getBoundingClie4.height;

          var originX = width / 2;
          var originY = height / 2;
          var moveX = x - originX;
          var moveY = y - originY;
          var translateX = (moveX * d - c * moveY) / (a * d - c * b);
          var translateY = (moveY * a - b * moveX) / (a * d - c * b);
          /**
           * Equals to
           * this.$translate(translateX, translateX);
           * this.$rotate(angle);
           * this.$translate(-translateX, -translateX);
           */

          this.$transform(scaleX, skewY, skewX, scaleY, translateX * (1 - scaleX) - translateY * skewX, translateY * (1 - scaleY) - translateX * skewY);
        } else {
          this.$transform(scaleX, skewY, skewX, scaleY, 0, 0);
        }
      }

      return this;
    }
    /**
     * Zooms the image.
     * @param {number} scale The zoom factor. Positive numbers for zooming in, and negative numbers for zooming out.
     * @param {number} [x] The zoom origin in the horizontal, defaults to the center of the image.
     * @param {number} [y] The zoom origin in the vertical, defaults to the center of the image.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$zoom",
    value: function $zoom(scale, x, y) {
      if (!this.scalable || scale === 0) {
        return this;
      }

      if (scale < 0) {
        scale = 1 / (1 - scale);
      } else {
        scale += 1;
      }

      if (isNumber(x) && isNumber(y)) {
        var _this$$matrix5 = _slicedToArray(this.$matrix, 4),
            a = _this$$matrix5[0],
            b = _this$$matrix5[1],
            c = _this$$matrix5[2],
            d = _this$$matrix5[3];

        var _this$getBoundingClie5 = this.getBoundingClientRect(),
            width = _this$getBoundingClie5.width,
            height = _this$getBoundingClie5.height;

        var originX = width / 2;
        var originY = height / 2;
        var moveX = x - originX;
        var moveY = y - originY;
        var translateX = (moveX * d - c * moveY) / (a * d - c * b);
        var translateY = (moveY * a - b * moveX) / (a * d - c * b);
        /**
         * Equals to
         * this.$translate(translateX, translateX);
         * this.$scale(scale);
         * this.$translate(-translateX, -translateX);
         */

        this.$transform(scale, 0, 0, scale, translateX * (1 - scale), translateY * (1 - scale));
      } else {
        this.$scale(scale);
      }

      return this;
    }
    /**
     * Scales the image.
     * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/scale}
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/scale}
     * @param {number} x The scaling factor in the horizontal direction.
     * @param {number} [y] The scaling factor in the vertical direction.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$scale",
    value: function $scale(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;

      if (this.scalable) {
        this.$transform(x, 0, 0, y, 0, 0);
      }

      return this;
    }
    /**
     * Skews the image.
     * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/skew}
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/transform}
     * @param {number|string} x The skewing angle in the horizontal direction.
     * @param {number|string} [y] The skewing angle in the vertical direction.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$skew",
    value: function $skew(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this.skewable) {
        var radianX = toAngleInRadian(x);
        var radianY = toAngleInRadian(y);
        this.$transform(1, Math.tan(radianY), Math.tan(radianX), 1, 0, 0);
      }

      return this;
    }
    /**
     * Translates the image.
     * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/translate}
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/translate}
     * @param {number} x The translating distance in the horizontal direction.
     * @param {number} [y] The translating distance in the vertical direction.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$translate",
    value: function $translate(x) {
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;

      if (this.translatable && isNumber(x) && isNumber(y)) {
        this.$transform(1, 0, 0, 1, x, y);
      }

      return this;
    }
    /**
     * Transforms the image.
     * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/matrix}
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/transform}
     * @param {number} a The scaling factor in the horizontal direction.
     * @param {number} b The skewing angle in the vertical direction.
     * @param {number} c The skewing angle in the horizontal direction.
     * @param {number} d The scaling factor in the vertical direction.
     * @param {number} e The translating distance in the horizontal direction.
     * @param {number} f The translating distance in the vertical direction.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$transform",
    value: function $transform(a, b, c, d, e, f) {
      if (isNumber(a) && isNumber(b) && isNumber(c) && isNumber(d) && isNumber(e) && isNumber(f)) {
        return this.$setTransform(multiplyMatrices(this.$matrix, [a, b, c, d, e, f]));
      }

      return this;
    }
    /**
     * Resets (overrides) the current transform to the specific identity matrix.
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setTransform}
     * @param {number|Array} a The scaling factor in the horizontal direction.
     * @param {number} b The skewing angle in the vertical direction.
     * @param {number} c The skewing angle in the horizontal direction.
     * @param {number} d The scaling factor in the vertical direction.
     * @param {number} e The translating distance in the horizontal direction.
     * @param {number} f The translating distance in the vertical direction.
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$setTransform",
    value: function $setTransform(a, b, c, d, e, f) {
      if (this.rotatable || this.scalable || this.skewable || this.translatable) {
        if (Array.isArray(a)) {
          var _a2 = a;

          var _a3 = _slicedToArray(_a2, 6);

          a = _a3[0];
          b = _a3[1];
          c = _a3[2];
          d = _a3[3];
          e = _a3[4];
          f = _a3[5];
        }

        if (isNumber(a) && isNumber(b) && isNumber(c) && isNumber(d) && isNumber(e) && isNumber(f)) {
          var oldMatrix = _toConsumableArray(this.$matrix);

          var newMatrix = [a, b, c, d, e, f];

          if (this.$emit(EVENT_TRANSFORM, {
            matrix: newMatrix,
            oldMatrix: oldMatrix
          }) === false) {
            return this;
          }

          this.$matrix = newMatrix;
          this.style.transform = "matrix(".concat(newMatrix.join(', '), ")");
        }
      }

      return this;
    }
    /**
     * Retrieves the current transformation matrix being applied to the element.
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/getTransform}
     * @returns {Array} Returns the readonly transformation matrix.
     */

  }, {
    key: "$getTransform",
    value: function $getTransform() {
      return this.$matrix.slice();
    }
    /**
     * Resets the current transform to the initial identity matrix.
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/resetTransform}
     * @returns {CropperImage} Returns `this` for chaining.
     */

  }, {
    key: "$resetTransform",
    value: function $resetTransform() {
      return this.$setTransform([1, 0, 0, 1, 0, 0]);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return _get(_getPrototypeOf(CropperImage), "observedAttributes", this).concat(NATIVE_ATTRIBUTES, ['initial-center-size', 'rotatable', 'scalable', 'skewable', 'translatable']);
    }
  }]);

  return CropperImage;
}(CropperElement);

CropperImage.$name = CROPPER_IMAGE;
CropperImage.$version = '2.1.0';
export { CropperImage as default };